const setChatPopupMessageStyles = (root, domChatObject) => {
    const { rdChat: domChat } = domChatObject;
    root.documentElement.style.setProperty('--headerColor', domChat.general.headerColor);
    root.documentElement.style.setProperty('--headerFontColor', domChat.general.headerFont.color);
    root.documentElement.style.setProperty('--sendbuttonColor', domChat.general.headerColor);

    if (domChat.branding && domChat.branding.brandingIsEnabled) {
        root.documentElement.style.setProperty('--brandColor', domChat.branding.brandColorCode);
        root.documentElement.style.setProperty('--headerColor', domChat.branding.brandColorCode);
        root.documentElement.style.setProperty(
            '--sendbuttonColor',
            domChat.branding.brandColorCode
        );

        root.documentElement.style.setProperty('--brandColorOpacity', domChat.brandColorOpacity);
        root.documentElement.style.setProperty('--headerFontColor', domChat.whiteText);
    }
};
export default setChatPopupMessageStyles;
